/* eslint-disable no-param-reassign */
import Vue from 'vue';
import $store from '@/store';

function commentNode(el, vnode) {
  const comment = document.createComment(' ');

  Object.defineProperty(comment, 'setAttribute', {
    value: () => undefined,
  });

  vnode.text = ' ';
  vnode.elm = comment;
  vnode.isComment = true;
  vnode.context = undefined;
  vnode.tag = undefined;
  vnode.data.directives = undefined;

  if (vnode.componentInstance) {
    vnode.componentInstance.$el = comment;
  }

  if (el.parentNode) {
    el.parentNode.replaceChild(comment, el);
  }
}

Vue.directive('acl', {
  bind(el, binding, vnode) {
    const aclType = binding.arg;

    if (aclType === 'user') {
      const permission = Object.keys(binding.modifiers)[0];
      if (!$store.getters['authorization/acl'].hasPermission(permission)) commentNode(el, vnode);
    }
  },
});
